import { render, staticRenderFns } from "./main-story.vue?vue&type=template&id=5c66180e&scoped=true&"
import script from "./main-story.vue?vue&type=script&lang=js&"
export * from "./main-story.vue?vue&type=script&lang=js&"
import style0 from "./main-story.vue?vue&type=style&index=0&id=5c66180e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66180e",
  null
  
)

export default component.exports